import styled from 'styled-components'

const variantBackground = {
  success: 'rgba(231, 249, 231, 1)',
  fail: 'rgba(252, 233, 233, 1)',
  error: 'rgba(244, 67, 54, 0.12)',
  information: 'rgba(254, 244, 221, 1)'
}

export const Container = styled.div`
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 9999;
  min-width: 320px;
  max-width: 420px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px 18px;
  border-radius: 14px;
  background: ${({ variant }) => variantBackground[variant] || variantBackground.information};
  color: #111111;
  box-shadow: 0 18px 38px rgba(7, 24, 46, 0.14);
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transform: translateY(${({ visible }) => (visible ? '0' : '-16px')});
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  transition:
    opacity 240ms ease,
    transform 240ms ease,
    visibility 240ms ease;
  pointer-events: ${({ visible }) => (visible ? 'auto' : 'none')};
  word-break: break-word;
`

export const Icon = styled.div`
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  display: grid;
  place-items: center;
  background: transparent;
  color: #121212;
  > svg {
    width: 20px;
    height: 20px;
  }
`

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #111111;
`

export const Message = styled.div`
  font-size: 13px;
  line-height: 1.5;
  color: #111111;
`

export const CloseButton = styled.button`
  border: none;
  background: transparent;
  color: #111111;
  cursor: pointer;
  padding: 0;
  margin: 0;
  font-size: 18px;
  line-height: 1;
`
